let config = {}

if(typeof(window) != 'undefined' && window.__INITIAL_CONFIG__){
	config = window.__INITIAL_CONFIG__
}else{
	try{
		config = require('../.env.js')
	}catch(e){
		console.log("No .env file found")
	}
}

if(__DEV__){
	console.log("Config: ", config)
}

export default config



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/config.js